export function EvidenceLink({
	evidence,
	onOpen,
}: {
	evidence: string | null | undefined;
	onOpen?: (evidence: string) => void;
}) {
	if (evidence === null || evidence === undefined) {
		return null;
	}

	if (onOpen === undefined) {
		return <span className="text-xs text-muted-foreground">{evidence}</span>;
	}

	return (
		<button
			type="button"
			className="text-xs text-primary underline-offset-2 hover:underline"
			onClick={() => onOpen(evidence)}
		>
			{evidence}
		</button>
	);
}
